<mat-tab-group
  class="tab-group"
  [mat-stretch-tabs]="false"
  color="warn"
  libTabActivated
>
  <mat-tab>
    <ng-template mat-tab-label class="mat-tab-label">
      <mat-icon [svgIcon]="EsvgFiles.document"/>
    </ng-template>

    <ng-template matTabContent>
      <app-tariff-groups/>
    </ng-template>
  </mat-tab>

  <mat-tab>
    <ng-template mat-tab-label class="mat-tab-label">
      <mat-icon [svgIcon]="EsvgFiles.list"/>
    </ng-template>

    <ng-template matTabContent>
      <app-tariff-types/>
    </ng-template>
  </mat-tab>

  <mat-tab>
    <ng-template mat-tab-label class="mat-tab-label">
      <mat-icon [svgIcon]="EsvgFiles.money"/>
    </ng-template>

    <ng-template matTabContent>
      <app-tariff-keys/>
    </ng-template>
  </mat-tab>
</mat-tab-group>

